// src/Toaster.tsx
import React, { useState, useEffect } from 'react';

type ToastMessage = {
  id: number;
  type: 'success' | 'error';
  message: string;
};

type ToasterProps = {
  maxToasts?: number; // Maximum number of toasts to show at once
};

const AlfinderToaster: React.FC<ToasterProps> = ({ maxToasts = 5 }) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handler = (event: CustomEvent<ToastMessage>) => {
      setMessages((prev) => {
        const updatedMessages = [...prev, { ...event.detail, id: Date.now() }];
        return updatedMessages.length > maxToasts
          ? updatedMessages.slice(-maxToasts)
          : updatedMessages;
      });

      setTimeout(() => {
        setMessages((prev) => prev.slice(1));
      }, 3000); // Auto-dismiss after 3 seconds
    };

    window.addEventListener('show-toast', handler as EventListener);
    return () =>
      window.removeEventListener('show-toast', handler as EventListener);
  }, [maxToasts]);

  return (
    <div style={styles.container}>
      {messages.map((msg) => (
        <div
          key={msg.id}
          style={{
            ...styles.toast,
            backgroundColor: msg.type === 'success' ? '#4caf50' : '#f44336', // Green for success, Red for error
          }}
        >
          {msg.message}
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 111111111,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  } as React.CSSProperties,
  toast: {
    padding: '10px 20px',
    color: '#fff',
    borderRadius: '5px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
  } as React.CSSProperties,
};

export default AlfinderToaster;
